import axios from "axios";

export const systemInfoService = {
    getSystemInfo,
};

function getSystemInfo() {
    return axios.get(window.REACT_APP_RUNTIME_ENVIRONMENT + '/mainpage/getSystemInfo');
}
